import { ApolloError } from '@apollo/client';

const stockLockService = {
  stockLockExtensions: ['stock_lock', 'stock_lock_selection_manual', 'stock_lock_selection_automatic'],

  hasStockLock(customizeCarError: ApolloError): boolean {
    const { extensions } = customizeCarError?.graphQLErrors[0] || {};
    if (!extensions) {
      return false;
    }

    return Object.keys(extensions).some(key => this.stockLockExtensions.includes(key));
  },
};

export default stockLockService;
